"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailUserAddRequestToJSON = exports.MailUserAddRequestFromJSONTyped = exports.MailUserAddRequestFromJSON = void 0;
var _1 = require("./");
function MailUserAddRequestFromJSON(json) {
    return MailUserAddRequestFromJSONTyped(json, false);
}
exports.MailUserAddRequestFromJSON = MailUserAddRequestFromJSON;
function MailUserAddRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        email: json['email'],
        password: json['password'],
        privileges: _1.MailUserPrivilegeFromJSON(json['privileges']),
    };
}
exports.MailUserAddRequestFromJSONTyped = MailUserAddRequestFromJSONTyped;
function MailUserAddRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        email: value.email,
        password: value.password,
        privileges: _1.MailUserPrivilegeToJSON(value.privileges),
    };
}
exports.MailUserAddRequestToJSON = MailUserAddRequestToJSON;
